import React from "react";
// import whitelogo from "../assets/imgTwo/logo-white.svg";
import "../App.css";
// import { FaTwitter } from "react-icons/fa";
// import { FaFacebookSquare } from "react-icons/fa";
// import { FaLinkedin } from "react-icons/fa";
// import { FaInstagramSquare } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";


export const HeroSection = () => {
  return (
    <section
      id="about"
      className="bg-hero-section animate-slidein text-white h-screen"
    >
      <div className="px-2 flex-row justify-center text-center text-white items-center">
        <div className="w-full">
          <h2 className="text-2xl md:text-[3.5rem] font-bold leading-normal pt-24">
            Powering Financial Institutions with<br></br> Scalable Digital Banking
          </h2>
          <p className="text-gray-800 text-white mt-4">
            Financial institutions need modern infrastructure to scale operations<br></br> and provide digital-first banking experiences.
           </p>
        </div>

      </div>
    </section>
  );
};

const AboutSection = () => (
  <section
    id="home"
    className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container mx-auto">
     <h2 className="text-center md:text-4xl font-bold">What Financial Institutions Can Achieve <br></br>
     with Uniswitch</h2>
     <div className="md:flex space-x-4">
      <div className="bg-[#07775D] flex-col justify-center rounded-lg p-4 py-12 mt-8 text-white px-[3em]  mx-auto w-[22em]">
        <h3 className="font-bold text-xl mb-4"> Digital Banking as a Service (DBaaS)</h3>
        <p>Launch and manage digital banking operations with ready-to-integrate infrastructure.</p>
      </div>
      <div className="bg-[#07775D] flex-col justify-center rounded-lg p-4 py-12 mt-8 text-white px-[3em]  mx-auto w-[22em]">
        <h3 className="font-bold text-xl mb-4"> Agency Banking Solutions</h3>
        <p>Extend financial services to underserved areas through a scalable agent network.</p>
      </div>
      <div className="bg-[#07775D] flex-col justify-center rounded-lg p-4 py-12 mt-8 text-white px-[3em] mx-auto w-[22em]">
        <h3 className="font-bold text-xl mb-4"> Real-Time Payment Processing</h3>
        <p>Enable instant interbank transfers, settlements, and transaction visibility.</p>
      </div>
      <div className="bg-[#07775D] flex-col justify-center rounded-lg p-4 py-12 mt-8 text-white px-[3em] mx-auto w-[22em]">
        <h3 className="font-bold text-xl mb-4"> Pension Remittance Integration</h3>
        <p>Automate and streamline pension contributions. Uniswitch’s Pension Remittance solution connects seamlessly with payroll systems for bulk payments, regulatory compliance, and transparent reporting.</p>
      </div>
     </div>
    </div>

  </section>
);




export const FinancialInstitutions = () => (
  <div className="font-san mx-auto bg-[#001100] pt-6">
          <Navbar />
    <HeroSection />
    <AboutSection />
    <Footer />
  </div>
);

export default FinancialInstitutions;
